// Import Libs and Handlers
import React from 'react';
import Renderer from '@tencent/gems-renderer-react';
import { withJimuComponentAdaptor } from '@tencent/gems-component-adaptor/esm/jimu';
import { injectStyle } from '../handlers/shared/injectStyle';
import { selectVersion } from '../handlers/shared/selectVersion';

// Import Components
import PageContainer from '../libraries/shadow_ai/components/PageContainer';
import H5BabyIndexPage from '../libraries/shadow_ai/components/H5BabyIndexPage';
import H5BabyChooseImagePage from '../libraries/shadow_ai/components/H5BabyChooseImagePage';
import H5BabyCropPage from '../libraries/shadow_ai/components/H5BabyCropPage';
import H5BabyResultPage from '../libraries/shadow_ai/components/H5BabyResultPage';
import H5BabyGuestPage from '../libraries/shadow_ai/components/H5BabyGuestPage'

// Import Plugins


// Import Actions


let ReactDOMServer;
if(process.env.SSR) {
  // TODO: Remove
  require('@babel/polyfill/noConflict');
  ReactDOMServer = require('react-dom/server');
}

// Global Style
injectStyle(`body {
	border: 1px none #161616 !important;
background-color: #ffffff !important;
background-repeat: repeat-y !important;
background-size: auto !important;
background-position: center top !important;
}`, '__impage_injected-global-styles');

// Auto Inject Style
injectStyle(``, '__impage_injected-component-styles');

// Global Data
const meta = {
    "title": "未来宝宝预测",
    "desc": "快来看看我和TA未来的宝宝长相",
    "start": new Date('Fri Jun 25 2021 09:40:18 GMT+0800 (China Standard Time)'),
    "end": new Date('Fri Jul 09 2021 09:40:18 GMT+0800 (China Standard Time)'),
    "actId": 6933,
    "actKey": "baby-born",
    "containerType": "web",
    "isTemplate": false,
    "isEditor": false,
    "isTestEnv": false
};

const _global = {
    "commonData": [
        {
            "key": "qqSource",
            "value": "未来宝宝预测"
        }
    ],
    "reportId": "baby_born"
};

// Inject JIMU_Vars
if (typeof window !== 'undefined') {
  if(!window['JIMU_VARS']){
    Object.defineProperty(window, 'JIMU_VARS', {
      value: {
    "key": "baby-born",
    "actStartTime": "2021-06-25T01:40:18.000Z",
    "actEndTime": "2021-07-09T01:40:18.000Z",
    "isJimu": false,
    "commonData": [
        {
            "key": "qqSource",
            "value": "未来宝宝预测"
        }
    ],
    "reportId": "baby_born"
},
      writable: false,
      configurable: false,
    });
  }

  // Inject Global
  if(!window['VISION']){
    Object.defineProperty(window, 'VISION', {
      value: { meta, global: _global },
      writable: false,
      configurable: false,
    });
  }
}

// Actions
const actions = {};

// Components
const components = {
    "124": {
        "component": PageContainer,
        "id": 124,
        "projId": 13,
        "projKey": "shadow_ai",
        "name": "PageContainer",
        "info": {
            "name": "多页面容器",
            "desc": "多页面容器",
            "author": "timshen"
        }
    },
    "263": {
        "component": H5BabyChooseImagePage,
        "id": 263,
        "projId": 13,
        "projKey": "shadow_ai",
        "name": "H5BabyChooseImagePage",
        "info": {
            "name": "H5BabyChooseImagePage",
            "desc": "生小孩H5选图页面",
            "author": "yorkshi"
        }
    },
    "264": {
        "component": H5BabyCropPage,
        "id": 264,
        "projId": 13,
        "projKey": "shadow_ai",
        "name": "H5BabyCropPage",
        "info": {
            "name": "生小孩裁图页",
            "desc": "生小孩裁图页面",
            "author": "zedyang"
        }
    },
    "265": {
        "component": H5BabyGuestPage,
        "id": 265,
        "projId": 13,
        "projKey": "shadow_ai",
        "name": "H5BabyGuestPage",
        "info": {
            "name": "H5生小孩客态页面",
            "desc": "客态页面",
            "author": "yorkshi"
        }
    },
    "266": {
        "component": H5BabyIndexPage,
        "id": 266,
        "projId": 13,
        "projKey": "shadow_ai",
        "name": "H5BabyIndexPage",
        "info": {
            "name": "H5BabyIndexPage",
            "desc": "生小孩H5首页",
            "author": "yorkshi"
        }
    },
    "267": {
        "component": H5BabyResultPage,
        "id": 267,
        "projId": 13,
        "projKey": "shadow_ai",
        "name": "H5BabyResultPage",
        "info": {
            "name": "生小孩结果页",
            "desc": "结果页面",
            "author": "zedyang"
        }
    }
};

// Plugin
const plugins = {};

// SchemaMap
const schemaMap = {
    "v7eb3b60": {
        "components": [
            {
                "id": 124,
                "key": 0,
                "data": {
                    "visible": false,
                    "pageId": "index",
                    "imgUrl": "",
                    "bgColor": "",
                    "isReportPV": true,
                    "isNeedRoute": false
                },
                "style": {
                    "color": "#000000"
                },
                "commonStyle": {},
                "wrapperStyle": {},
                "actions": [],
                "children": [
                    {
                        "id": 266,
                        "key": 4,
                        "data": {
                            "materialConfigList": {
                                "materialName": "baby",
                                "thumbnailImageUrl": "https://xmaterial.tu.qq.com/xmaterial/materials/77675f50-da31-11eb-b3ef-0af30d6597c8-share_pic.png",
                                "previewImageUrl": "https://xmaterial.tu.qq.com/xmaterial/materials/77675f50-da31-11eb-b3ef-0af30d6597c8-share_pic.png",
                                "businessId": "become_child_mix_entry",
                                "extraInfo": "{\"become_child_mix_entry\":{\"busiId\":\"become_child_mix_entry\",\"mid\":\"child_smile\"}}",
                                "isNeedFaceDetect": true,
                                "isNeedCrop": true
                            },
                            "backgroundImageUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600699517.png?imageView2/2/w/2000/format/webp/q/80!",
                            "playBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1624611839053.png?imageView2/2/w/2000/format/webp/q/80!",
                            "titleUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600774395.png?imageView2/2/w/2000/format/webp/q/80!",
                            "contentUrl": "//i.vision.qq.com/prod/imgs/static/static_1624865424974.png?imageView2/2/w/2000/format/webp/q/80!",
                            "privacyCheckedImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1621934155237.png?imageView2/2/w/2000/format/webp/q/80!",
                            "privacyTitle": "活动规则和个人信息保护指引",
                            "privacyContent": "欢迎参与QQ【未来宝宝预测】活动（“本活动”），本活动由腾讯公司运营。参与本活动时，您将上传的含有您的头像的照片，系统将通过后期技术将您提交的照片叠加到视频中，并在活动页面内生成新的短视频。 在此过程中，您所上传照片中的人脸的肖像将仅被用于本活动，在您关闭活动页面后，我们将不会保存您所上传的照片。      当您点击我已知晓信息保护声明及活动规则按钮表示您已同意并接受以下所述条款和条件及同意受本规则与声明约束。 1.\t在您进入活动页面后，您将需要上传您本人的照片，您针对本次活动所上传照片中的人脸的肖像将仅被用于本次活动；在您关闭活动页面后，腾讯公司将不会保存您所上传的照片。 2.\t您保证对于上传的内容拥有相应的合法权利并有权用于参与本活动，且腾讯公司有权根据活动需求使用相关内容。否则，造成的一切后果及损失由您自行承担。 3.\t腾讯公司将根据本规则与声明尽最大努力在合理、必要且明示的范围内使用您授予的内容，且您的必要授权与同意并不改变您对肖像权的归属，更不影响您对您本人肖像权任何合法使用。 4.\t您可将活动页面内生成的图片贺卡保存至您的手机相册。同时，您可将活动页面内生成的视频祝福发送给您的QQ好友或发布至您的QQ空间；在您选择上述操作后，您将需要遵循手机QQ客户端和/或QQ空间的使用条款和隐私政策。 5.\t除您所上传的内容之外，本活动所使用的素材为腾讯公司享有完整版权。您通过本活动页面上传、观看、分享、保存、修改、传播、发布的任何图片、视频及其他内容，仅限您个人的非商业性质用途；未经腾讯公司事先书面许可，您不得该等图片、短视频用于任何商业目的或任何营利性活动，仅可在法律法规允许的范围内以社交为目的进行非商业性的信息网络传播。否则，造成的一切后果及损失由您自行承担。 6.\t个人信息保护 （1）我们会按照适用的法律法规和任何相关的保密安全条款来使用您的个人信息。您同意免除上述个人信息的接收和/或使用方在按照本法律声明所述情形下进行信息披露和使用而导致的或可能导致的所有索赔、责任和损失。当我们要将信息用于本声明未载明的其他用途时，会事先征求您的同意。 （2） 我们严格遵守法律法规保护您的个人信息，在合理的安全水平内使用各种安全保护措施以保障您个人信息的安全，以防止信息的丢失、不当使用、未经授权访问或披露。 （3） 如果您对个人信息保护问题有任何疑问或投诉，您可以联系我们。联系方式请参阅《腾讯隐私政策》（privacy.qq.com）“联系我们”一节。 7.\t在法律允许的最大限度内，您保证并同意保证腾讯公司在任何时间均不会因您的任何行动、违约或疏忽和/或违反本规则所述任何保证而承担任何责任、索赔、要求、损失、损害赔偿金、费用及开支。在法律允许的最大限度内，您同意对因以下原因或行为而产生的任何和所有索赔、行动、诉讼或诉讼程序，以及任何和所有损失、责任、损害赔偿金、费用和开支（包括合理的律师费）为腾讯公司进行抗辩并向腾讯公司赔偿上述费用，使其免受损害： （1）您上传或以其他方式提供侵犯任何人知识产权或其他合法权益的任何资料； （2）您做出与活动相关的任何虚假陈述； （3）您不遵守适用法律法规，或违反本规则和/或其他相关规则的规定； （4）您参与活动而导致第三方提出索赔； （5）您的任何其他行为、过失或疏忽。 8.\t本活动过程中会受到包括但不限于如下不可抗力或者其他因素的影响：政治原因、社会环境、自然灾害、经济危机、计算机病毒或黑客攻击、服务器或系统不稳定、您所在的特殊位置、任何技术能力、网络质量以及通信线路、计算机故障等（以下统称“免责事由”）。若出现上述免责事由情况时，腾讯公司将尽努力进行修复或者及时补救，给您造成损失的，腾讯公司在法律与政策允许的范围内免责。在任何情况下，腾讯公司均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您参与本活动而遭受的利润损失，承担责任（即使腾讯公司已被告知该等损失的可能性亦然）。尽管本规则中可能含有相悖的规定，腾讯公司对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因参与本活动而支付给腾讯公司的费用(如有)。 9.\t除本规则另有规定外，腾讯公司有权根据商业判断对活动页面进行变更、中断或终止。除其他规则或文件另有规定外，腾讯公司不对相应变更、中断或终止承担任何责任。 10.\t若因本活动产生任何纠纷的，均应提交至腾讯公司所在地深圳市南山区(即本规则的签署地)法院解决，并适用中华人民共和国大陆地区法律。   腾讯公司",
                            "bottomLogoUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600850855.png?imageView2/2/w/2000/format/webp/q/80!",
                            "contentGifUrl": "//i.vision.qq.com/prod/imgs/static/static_1624946424903.gif"
                        },
                        "style": {
                            "color": "#000000"
                        },
                        "commonStyle": {},
                        "wrapperStyle": {},
                        "actions": []
                    }
                ]
            },
            {
                "id": 124,
                "key": 1,
                "data": {
                    "visible": false,
                    "pageId": "choose_image",
                    "imgUrl": "",
                    "bgColor": "",
                    "isReportPV": true,
                    "isNeedRoute": false
                },
                "style": {
                    "color": "#000000"
                },
                "commonStyle": {},
                "wrapperStyle": {},
                "actions": [],
                "children": [
                    {
                        "id": 263,
                        "key": 5,
                        "data": {
                            "faceRatio": 0.3,
                            "playBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1624946510095.png?imageView2/2/w/2000/format/webp/q/80!",
                            "motherChooseIcon": "//i.vision.qq.com/prod/imgs/static/static_1624600974851.png?imageView2/2/w/2000/format/webp/q/80!",
                            "fatherChooseIcon": "//i.vision.qq.com/prod/imgs/static/static_1624600974879.png?imageView2/2/w/2000/format/webp/q/80!",
                            "backgroundUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600699517.png?imageView2/2/w/2000/format/webp/q/80!",
                            "titleImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600974891.png?imageView2/2/w/2000/format/webp/q/80!",
                            "maleReselectImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600974883.png?imageView2/2/w/2000/format/webp/q/80!",
                            "femalReselectImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600975209.png?imageView2/2/w/2000/format/webp/q/80!",
                            "tipImageUrl": "//i.vision.qq.com/prod/imgs/static/static_1624946518825.png?imageView2/2/w/2000/format/webp/q/80!",
                            "loadingImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042199258.gif"
                        },
                        "style": {
                            "color": "#000000"
                        },
                        "commonStyle": {},
                        "wrapperStyle": {},
                        "actions": []
                    }
                ]
            },
            {
                "id": 124,
                "key": 2,
                "data": {
                    "visible": false,
                    "pageId": "crop",
                    "imgUrl": "",
                    "bgColor": "",
                    "isReportPV": true,
                    "isNeedRoute": false
                },
                "style": {
                    "color": "#000000"
                },
                "commonStyle": {},
                "wrapperStyle": {},
                "actions": [],
                "children": [
                    {
                        "id": 264,
                        "key": 6,
                        "data": {
                            "backgroundUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600699517.png?imageView2/2/w/2000/format/webp/q/80!",
                            "maskImageUrl": "//i.vision.qq.com/prod/imgs/static/static_1624601117654.png?imageView2/2/w/2000/format/webp/q/80!",
                            "submitBtnImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1624611877484.png?imageView2/2/w/2000/format/webp/q/80!",
                            "changePicUrl": "//i.vision.qq.com/test/imgs/static/static_1624003566221.png?imageView2/2/w/2000/format/webp/q/80!",
                            "cropTipUrl": "//i.vision.qq.com/prod/imgs/static/static_1624601191835.png?imageView2/2/w/2000/format/webp/q/80!",
                            "logoUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600850855.png?imageView2/2/w/2000/format/webp/q/80!",
                            "loadingUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042199258.gif"
                        },
                        "style": {
                            "color": "#000000"
                        },
                        "commonStyle": {},
                        "wrapperStyle": {},
                        "actions": []
                    }
                ]
            },
            {
                "id": 124,
                "key": 3,
                "data": {
                    "visible": true,
                    "pageId": "result",
                    "imgUrl": "",
                    "bgColor": "",
                    "isReportPV": true,
                    "isNeedRoute": false
                },
                "style": {
                    "color": "#000000"
                },
                "commonStyle": {},
                "wrapperStyle": {},
                "actions": [],
                "children": [
                    {
                        "id": 267,
                        "key": 7,
                        "data": {
                            "resultPageShareMsg": "快来看看我和TA未来的宝宝长相",
                            "backgroundImageUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600699517.png?imageView2/2/w/2000/format/webp/q/80!",
                            "videoFrameImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1624601333950.png?imageView2/2/w/2000/format/webp/q/80!",
                            "adBannerUrl": "//i.vision.qq.com/prod/imgs/static/static_1625832117204.gif?imageView2/2/w/2000/format/webp/q/80!",
                            "adBannerBackUrl": "//i.vision.qq.com/prod/imgs/static/static_1624612132072.png?imageView2/2/w/2000/format/webp/q/80!",
                            "adBannerSchema": "https://tu.qq.com/downloading.php?by=81",
                            "replayBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042199149.png?imageView2/2/w/2000/format/webp/q/80!",
                            "shareBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1624611899508.png?imageView2/2/w/2000/format/webp/q/80!",
                            "saveBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1625641757254.png?imageView2/2/w/2000/format/webp/q/80!",
                            "saveVideoBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1624611899508.png?imageView2/2/w/2000/format/webp/q/80!",
                            "saveQQImageBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1624611930067.png?imageView2/2/w/2000/format/webp/q/80!",
                            "videoModalLongPressDownloadImageUrl": "//i.vision.qq.com/prod/imgs/static/static_1624601599940.png?imageView2/2/w/2000/format/webp/q/80!",
                            "loadingImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042199258.gif",
                            "selectBoyUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042199167.png?imageView2/2/w/2000/format/webp/q/80!",
                            "selectGirlUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042199239.png?imageView2/2/w/2000/format/webp/q/80!",
                            "downloadUrl": "//i.vision.qq.com/test/imgs/static/static_1624015398921.png?imageView2/2/w/2000/format/webp/q/80!",
                            "feedImageUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042288831.png?imageView2/2/w/2000/format/webp/q/80!",
                            "feedUrl": "https://support.qq.com/products/333804",
                            "adBannerGif": "//i.vision.qq.com/prod/imgs/static/static_1625832138465.png?imageView2/2/w/2000/format/webp/q/80!",
                            "logoUrl": "//i.vision.qq.com/prod/imgs/static/static_1625042199150.png?imageView2/2/w/2000/format/webp/q/80!",
                            "closeBtnImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1625646696844.png?imageView2/2/w/2000/format/webp/q/80!"
                        },
                        "style": {
                            "color": "#000000"
                        },
                        "commonStyle": {},
                        "wrapperStyle": {},
                        "actions": []
                    }
                ]
            },
            {
                "id": 124,
                "key": 9,
                "data": {
                    "visible": false,
                    "pageId": "guest_page",
                    "imgUrl": "",
                    "bgColor": "",
                    "isReportPV": true,
                    "isNeedRoute": false
                },
                "style": {
                    "color": "#000000"
                },
                "commonStyle": {},
                "wrapperStyle": {},
                "actions": [],
                "children": [
                    {
                        "id": 265,
                        "key": 10,
                        "data": {
                            "backgroundImageUrl": "//i.vision.qq.com/prod/imgs/static/static_1624600699517.png?imageView2/2/w/2000/format/webp/q/80!",
                            "playBtnUrl": "//i.vision.qq.com/prod/imgs/static/static_1624601709989.png?imageView2/2/w/2000/format/webp/q/80!",
                            "adBannerUrl": "//i.vision.qq.com/prod/imgs/static/static_1625831886124.gif?imageView2/2/w/2000/format/webp/q/80!",
                            "adBannerBackUrl": "//i.vision.qq.com/prod/imgs/static/static_1624612132072.png?imageView2/2/w/2000/format/webp/q/80!",
                            "adBannerSchema": "https://tu.qq.com/downloading.php?by=81",
                            "isVideo": true,
                            "shareImageUrl": "https://xmaterial.tu.qq.com/xmaterial/materials/77675f50-da31-11eb-b3ef-0af30d6597c8-share_pic.png",
                            "guestPageShareMsg": "快来看看我和TA未来的宝宝长相",
                            "adBannerGif": "//i.vision.qq.com/prod/imgs/static/static_1625832029087.png?imageView2/2/w/2000/format/webp/q/80!",
                            "videoFrameImgUrl": "//i.vision.qq.com/prod/imgs/static/static_1624601333950.png?imageView2/2/w/2000/format/webp/q/80!"
                        },
                        "style": {
                            "color": "#000000"
                        },
                        "commonStyle": {},
                        "wrapperStyle": {},
                        "actions": []
                    }
                ]
            }
        ],
        "plugins": [],
        "version": {
            "versionId": "v7eb3b60",
            "versionName": "v7eb3b60"
        }
    }
};

export default function App({ version }) {
  const schema = selectVersion(schemaMap, version);
  return (
    <Renderer
      schema={schema}
      materials={{ components, plugins, actions }}
      autoParseStyle={false}
      global={_global}
      meta={meta}
      withComponentAdaptor={withJimuComponentAdaptor}
    />
  );
}

export function renderToString() {
  return ReactDOMServer.renderToString(<App />);
}
